export default "__VITE_ASSET__BIgYPfhI__"